export default __webpack_public_path__ + "static/img-badge-3b1d69c64b89248a47887789c4d8430c.svg";